import { jsx } from 'react/jsx-runtime';
import events from 'events-bus';
import { createContext, useState, useEffect, useContext } from 'react';

const AppContext = createContext(null);
const useAppState = () => {
    const context = useContext(AppContext);
    if (context === null) {
        throw new Error('useAppState must be wrapped by an AppConfigurationProvider');
    }
    return context;
};
const AppProvider = ({ hasBonusPoints, domain, children, bundle, }) => {
    const [isLoggedIn, setIsLoggedIn] = useState(false);
    useEffect(() => {
        function listener(eventName, data) {
            setIsLoggedIn(data.authenticated);
        }
        events.on('AUTH-READY-v1', listener);
        return () => {
            events.off(listener);
        };
    }, []);
    return (jsx(AppContext.Provider, { value: {
            isLoggedIn,
            hasBonusPoints,
            domain,
            bundle,
        }, children: children }));
};
AppProvider.displayName = 'AppProvider';

export { AppProvider, useAppState };
//# sourceMappingURL=AppContext.js.map
